<template>
  <v-snackbar v-model="snackbar.open" :color="snackbar.color">
    {{ snackbar.message }}
  </v-snackbar>
</template>

<script setup>
import { useSnackbar } from '@/composables/useSnackbar'

const { snackbar } = useSnackbar()
</script>
